
export function convertArrToJSON(array, key){
    let obj = {};
    for(let i = 0; i < array.length; i++){
        obj[array[i][key]] = array[i]
    }
    return obj
}

export function acronym(str) {
    if (str && typeof str === 'string') return str.split(/\s/).map(i => i.charAt(0).toUpperCase())
}

export function acronym_name(str) {
    if (str && typeof str === 'string') return str.match(/^\w|\b\w(?=\S+$)/g).join('').toUpperCase()

}

export function allowOnlyNumbers(e) {
    if (!(
        (e.keyCode > 95 && e.keyCode < 106) ||
        (e.keyCode > 47 && e.keyCode < 58) ||
        [8, 9, 37, 39].includes(e.keyCode) ||
        ((e.keyCode == 65 || e.keyCode == 86 || e.keyCode == 67) && (e.ctrlKey === true || e.metaKey === true))
    )) {
        e.preventDefault()
    }
}

export function preventExponent(e) {
    if(e.keyCode === 69) e.preventDefault();
}

export function isEmptyOrSpaces(str) {
    return str === null || str.match(/^ *$/) !== null
}

export function getExtension(filename) {
    let arr = filename.split('.');
    return arr[arr.length - 1];
}

export function isImage(filename) {
    let ext = getExtension(filename);
    return ['jpg', 'jpeg', 'png', 'bmp', 'tif', 'gif', 'tiff', 'pjp', 'jfif', 'svg', 'svgz', 'webp', 'ico', 'xbm', 'dib', 'pjpeg', 'avif'].includes(ext.toLowerCase());
}

export function isVideo(filename) {
    let ext = getExtension(filename);
    return ['mp4', 'mpg', 'avi', 'm4v', 'webm', 'ogm', 'wmv', 'ogv', 'mov', 'asx', 'mpeg'].includes(ext.toLowerCase());
}

export function profitPercentage(purchasePrice, sellingPrice) {
    if(purchasePrice === 0) return 0;
    let value = ((sellingPrice - purchasePrice)/purchasePrice) * 100;
    return Math.round(value * 100) / 100;
}

export function roundOffValue(value){
    return Math.round(value * 100) / 100;
}